<template>
  <div class="report-page">
    <planning-nav/>
    <div class="content-main">
      <capacity-report :me-result="meResult" :comparison-result="comparisonResult" :family-name="familyName"/>
      <capacity-experience v-if="meExp && comparisonExp" :family-name="familyName" :comparison-exp="comparisonExp" :me-exp="meExp"/>
      <cv-analysis v-if="analysisVisibile" :me="meResult" :she="comparisonResult"/>
      <comparison-skill :skill="skill" :family-name="familyName"/>
      <competitive v-if="analysisVisibile" :me="meResult" :she="comparisonResult" :profession_name="profession_name" :skill="skill" :profession_id="profession_id"/>
      <recommend-jobs :profession-name="$route.query.profession_name"/>
      <robot :cv_token="cv_token" :typeStr="'userContrast'" :delayed="100" :showRobotContent="showRobot"></robot>
    </div>
    <img src="https://files.wondercv.com/PC/editor/planning/people/bg.png" alt="" class="background-image">
  </div>
</template>

<script>
  import PlanningNav from  "../components/planning-nav"
  import RecommendJobs from "../components/recommend-jobs"
  import CapacityReport from "../components/capacity-report"
  import ComparisonSkill from "../components/comparison-skill"
  import CapacityExperience from "../components/capacity-experience"
  import CvAnalysis from "../components/cv-analysis.vue"
  import competitive from "../components/competitive"
  import api from "../../../api/index"
  import Robot from '../components/robot.vue'
  export default {
    name: "planning-report",
    components: {PlanningNav, RecommendJobs, CapacityReport, ComparisonSkill, CapacityExperience,CvAnalysis,competitive, Robot},
    data(){
      return {
        familyName: "",
        skill: {
          me: [],
          comparison: []
        },
        meResult: null,
        comparisonResult: null,
        meExp: null,
        comparisonExp: null,
        profession_name:'',
        analysisVisibile:false,
        showRobot: false,
        cv_token: ''
      }
    },
    mounted() {
      this.initData()
      this.cv_token = this.$route.query.me_token
      window.addEventListener('scroll', this.scrollFunc);
      try {
        document.getElementsByTagName('body')[0].className += 'hide-udesk'
      } catch (error) {}
    },
    destroyed(){
      window.removeEventListener('scroll', this.scrollFunc);
    },
    methods: {
      async initData(){
        const {me_token, profession_id, user,profession_name} = this.$route.query;
        this.profession_name = profession_name
        this.profession_id = profession_id
        const {token: comparison_token } = this.$route.params
        this.familyName = user
        await Promise.all([
          api.planning.getReports({cv_token: me_token, profession_id}),
          api.planning.getReports({cv_token: comparison_token, profession_id}),
          api.planning.getExperience(me_token),
          api.planning.getExperience(comparison_token)
        ]).then((res) => {
          let [me, comparison, meExp, comparisonExp] = res
          if(me.code === 1000) {
            //处理雷达图分数
            this.meResult = me.data
            //处理技能
            this.skill.me = me.data.skills
          }
          if(comparison.code === 1000){
            //处理雷达图分数
            this.comparisonResult = comparison.data
            //处理技能
            this.skill.comparison = comparison.data.skills
          }
          if(meExp.code === 1000 && comparisonExp.code === 1000){
            this.meExp = [ ...meExp.data.edus.map(item => ({...item, type: 'school'})).reverse(), ...meExp.data.works.map(item => ({...item, type: 'company'})).reverse()]
            this.comparisonExp = [ ...comparisonExp.data.edus.map(item => ({...item, type: 'school'})).reverse(), ...comparisonExp.data.works.map(item => ({...item, type: 'company'})).reverse()]
            this.analysisVisibile = true
          }
        }).catch((err) => {
          console.log(err)
        })
        
      },
      scrollFunc(e){
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        // console.log(scrollTop);
        if(scrollTop > 1300) {
          this.showRobot = true
        }
      }
    }
  }
</script>

<style scoped lang="scss">
.report-page {
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  background-color: rgba(32, 35, 41, 1);
  padding-top: 100px;
  padding-bottom: 114px;
  position: relative;
  .content-main {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    position: relative;
    z-index: 1;
  }
  .background-image{
    position: absolute;
    z-index: 0;
    top: 35px;
    width: 300px;
    right: 0px
  }
}
</style>
